import React from 'react';
import Downshift from 'downshift';
import FetchSuggestions from './FetchSuggestions';
import {
  Popover,
  PopoverContent,
  PopoverItem,
  PopoverTrigger,
} from 'src/ui/popover';
import { cn } from '@lib/tw';

function renderSuggestion({
  suggestion,
  index,
  itemProps,
  highlightedIndex,
  selectedItem,
}) {
  const isHighlighted = highlightedIndex === index;
  const isSelected = (selectedItem || '').indexOf(suggestion) > -1;

  return (
    <PopoverItem
      key={suggestion}
      {...itemProps}
      className={cn(
        'py-4 px-4',
        isHighlighted ? 'bg-neutral-100/80' : '',
        isSelected ? 'bg-slate-100' : ''
      )}
    >
      {suggestion}
    </PopoverItem>
  );
}

const DownshiftInput = (props) => {
  const handleSelect = (selectedItem) => {
    props.selectSuggestions({ selectedItem });
  };

  const { defaultInputValue } = props;

  return (
    <Downshift
      onSelect={handleSelect}
      defaultInputValue={defaultInputValue}
      id="autocomplete"
      labelId="autocomplete-label"
      inputId="autocomplete-input"
      menuId="autocomplete-menu"
      onInputValueChange={props.onInputValueChange}
      stateReducer={(state, changes) => {
        if (changes.type === Downshift.stateChangeTypes.blurInput) {
          return {
            ...changes,
            inputValue: state.inputValue,
          };
        }

        if (
          changes.type === Downshift.stateChangeTypes.mouseUp ||
          changes.type === Downshift.stateChangeTypes.touchStart
        ) {
          return {
            ...changes,
            inputValue: state.inputValue,
            isOpen: true,
          };
        }

        return changes;
      }}
    >
      {({
        getInputProps,
        getItemProps,
        isOpen,
        inputValue,
        selectedItem,
        highlightedIndex,
        clearItems,
        closeMenu,
        setState,
      }) => (
        <div>
          {props.renderInput({
            InputProps: getInputProps({
              placeholder: props.placeholder,
              id: props.id,
              autoComplete: 'off',
            }),
            closeMenu,
            setState,
          })}
          {isOpen ? (
            <Popover
              open={true}
              defaultOpen={true}
              onOpenChange={() => {
                //
              }}
            >
              <PopoverTrigger className="absolute top-0 left-0 h-full w-full z-[-1]">
                {''}
              </PopoverTrigger>
              <PopoverContent
                className="w-[--radix-popper-anchor-width] mt-0 py-0"
                onOpenAutoFocus={(e) => e.preventDefault()}
              >
                <FetchSuggestions
                  searchValue={inputValue}
                  onLoaded={() => {
                    clearItems();
                  }}
                  limit={4}
                  render={({ loading, suggestions, error }) => {
                    if (loading || error || suggestions.length === 0) {
                      return null;
                    }
                    return suggestions.map((suggestion) =>
                      renderSuggestion({
                        suggestion,
                        index: suggestion,
                        itemProps: getItemProps({
                          index: suggestion,
                          key: suggestion,
                          item: suggestion,
                        }),
                        highlightedIndex,
                        selectedItem,
                      })
                    );
                    //
                  }}
                />
              </PopoverContent>
            </Popover>
          ) : null}
        </div>
      )}
    </Downshift>
  );
};

export default React.memo(DownshiftInput);
